import lazyLoad from 'app/shared-components/util/lazyLoad';

const NewPasswordPage = lazyLoad(() => import('./NewPasswordPage'));
import authRoles from '../../auth/authRoles';

const NewPasswordConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'new-password',
      element: <NewPasswordPage />,
    },
  ],
};

export default NewPasswordConfig;
